export default {
    setLoginStatus(state, payload) {
        state.isLogin = payload;
    },
    updateUserInfo(state, newUserInfo) {
        if (state.userInfo) {
            state.userInfo = { ...state.userInfo, ...newUserInfo };
        } else {
            state.userInfo = { ...newUserInfo };
        }
    },
    updateTransparent(state, isTransparent) {
        state.isTransparent = isTransparent;
    },
    updateFeedbackShow(state, val) {
        state.feedbackShow = val;
    },
    updateShowRenew(state, val) {
        state.showRenew = val;
    }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js